import React, { useEffect, useRef } from "react";
import styles from "./ChartEditor.module.css";
import {
	primaryTextColor,
	secondaryTextColor,
	fw400,
	titleS,
	titleM,
} from "../../../Global.module.css";
import { useOutsideClick } from "../../../helpers/useOutsideClick";
import Table from "./Table";
import Chart from "../../charts/helpers/Chart";
import { getConfigSwitch } from "./helpers/getConfigSwitch";

export default function ChartEditor({
	chartType,
	chartData,
	chartConfig,
	onChartConfigChange,
	onChartDataChange,
	closeEditor,
}) {
	const ref = useRef();

	useOutsideClick(ref, closeEditor);

	return (
		<div className={styles.chartEditor} ref={ref}>
			<p
				className={`${styles.closeBtn} ${secondaryTextColor} ${fw400} ${titleS}`}
				onClick={closeEditor}
			>
				X
			</p>
			<div className={styles.tableContainer}>
				<Table
					chartType={chartType}
					onChartDataChange={onChartDataChange}
					chartData={chartData}
				/>
			</div>
			<div className={styles.rightContainer}>
				<div className={styles.chartPreview}>
					<Chart
						chartType={chartType}
						chartData={chartData}
						chartConfig={chartConfig}
					/>
				</div>
				<div
					className={`${styles.configContainer} ${primaryTextColor} ${fw400} ${titleM}`}
				>
					{getConfigSwitch(
						chartType,
						chartConfig,
						onChartConfigChange
					) || null}
				</div>
			</div>
		</div>
	);
}
